import React, { useState, useEffect, useContext } from 'react';
import { ContextSession } from '../../services/ContextSession';
import { InputLabel, Typography, Container, Stack, Grid, RadioGroup, FormControlLabel, Radio, FormControl, Divider, TextField, Button, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import CheckCircle from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import { useNavigate } from 'react-router-dom';

function VerQuejasSugerencias() {
    let sessi = useContext(ContextSession);
    const [tipoSeleccionado, setTipoSeleccionado] = useState('');
    const [correlativo, setCorrelativo] = useState('');
    const [nombre, setNombre] = useState('');
    const [fecharegistro, setFechaRegistro] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [notaRevision, setNotaRevision] = useState('');
    const [loading, setLoading] = useState(false);
    const [estado, setEstado] = useState('');
    const [dialogOpen, setDialogOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        async function fetchData() {
           // console.log("LA DATA DESDE QUEJAS ES:", sessi.sessionData);
            setLoading(true);
            try {
                let sid = sessi.getVariable("IDquejasugerencia");
               // console.log("EL SID ES:", sid);
                //const response = await fetch(`http://172.20.7.10:8080/api/quejasSugerencias/${sid}/`, {
                const response = await fetch(`${sessi.ip}/api/quejasSugerencias/${sid}/`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${sessi.sessionData.token}` // Se añade el token aquí
                    }
                });
                const data = await response.json();
                //console.log(data);

                // Actualiza los valores en el formulario
                setEstado(data.estado);
                setNombre(data.nombre_participante);
                setCorrelativo(data.numerocorrelativo);
                setDescripcion(data.descripcion);
                setTipoSeleccionado(data.tipo === 1 ? 'Queja' : 'Sugerencia');

                // Si el estado es "Cerrado", hacer el campo de Nota de revisión solo lectura y establecer el valor
                if (data.estado === 'Cerrado') {
                    setNotaRevision(data.descripcioncierre);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [sessi]);


    const handleCloseCase = async () => {
        if (notaRevision.trim() === '') {
            alert("El campo 'Nota de revisión' no puede estar vacío.");
            return;
        }

        try {
            let sid = sessi.getVariable("IDquejasugerencia");
            const formData = new FormData();
            formData.append('idusuarioempleado', sessi.sessionData.id);
            formData.append('descripcioncierre', notaRevision);
            formData.append('fechacierre', new Date().toISOString());
            formData.append('estado', 'Cerrado');

            const response = await fetch(`${sessi.ip}/api/quejasSugerencias/${sid}/`, {
                method: 'PATCH',
                body: formData
            });

            if (response.ok) {
                setDialogOpen(true);
            } else {
                console.error("Error al cerrar el caso");
            }
        } catch (error) {
            console.error("Error al enviar la solicitud:", error);
        }
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
        navigate('/PortalDelParticipante/ListaQuejasSugerencias');
    };

    return (
        <>
            <Container style={{ marginTop: 30 }}>
                <Grid item>
                    <h3 style={{ textAlign: 'center' }}>UDI-F-01.1</h3>
                    <h1 style={{ textAlign: 'center' }}>Quejas y Sugerencias</h1>
                    <h1 style={{ textAlign: 'center' }}>{correlativo}</h1>
                </Grid>

                <Grid
                    item
                    container
                    alignItems="center"
                    justifyContent="center"
                    marginTop={3}
                    spacing={1}
                >
                    {estado === "Cerrado" ? (
                        <Typography variant="h6" style={{ color: 'green', display: 'flex', alignItems: 'center' }}>
                            <InputLabel><b>Estado:</b> </InputLabel>
                            <CheckCircle fontSize="small" style={{ marginLeft: 4, marginRight: 4 }} />
                            {estado}
                        </Typography>
                    ) : estado === "Pendiente" ? (
                        <Typography variant="h6" style={{ display: 'flex', alignItems: 'center', color: 'orange' }}>
                            <InputLabel><b>Estado:</b> </InputLabel>
                            <WarningIcon fontSize="small" style={{ marginLeft: 4, marginRight: 4 }} />
                            {estado}
                        </Typography>
                    ) : null}
                </Grid>
                <Divider />

                <Stack direction="column" alignItems="center" spacing={2} marginTop={5}>
                    <Grid item>
                        <h3 style={{ textAlign: 'center' }}>Nombre del participante: {nombre}</h3>
                    </Grid>
                    <Stack direction="row" alignItems="center" spacing={2}>
                        <label>TIPO SELECCIONADO:</label>
                        <FormControl component="fieldset">
                            <RadioGroup
                                id="grupoTipoPrestamo"
                                value={tipoSeleccionado}
                                row
                                aria-labelledby="Tipo Prestamo"
                                name="tipoPrestamo"
                            >
                                <FormControlLabel value="Queja" control={<Radio color="error" />} label="Queja" readOnly />
                                <FormControlLabel value="Sugerencia" control={<Radio color="error" />} label="Sugerencia" readOnly />
                            </RadioGroup>
                        </FormControl>
                    </Stack>

                    <TextField
                        label="Descripción:"
                        multiline
                        rows={4}
                        variant="filled"
                        fullWidth
                        style={{ marginTop: 10 }}
                        value={descripcion}
                        inputProps={{ readOnly: true }}
                    />
                </Stack>
                {estado === "Cerrado" && (
                    <>
                        <Divider style={{ marginTop: 60 }} />
                        <Stack direction="column" alignItems="center" spacing={2} marginTop={5}>
                            <TextField
                                label="Nota de revisión"
                                multiline
                                rows={4}
                                variant="filled"
                                fullWidth
                                style={{ marginTop: 20 }}
                                value={notaRevision}
                                onChange={(e) => setNotaRevision(e.target.value)}
                                inputProps={{ readOnly: true }}
                            />

                        </Stack>
                    </>
                )}
            </Container>

            <Dialog open={dialogOpen} onClose={handleDialogClose}>
                <DialogTitle>Datos Enviados</DialogTitle>
                <DialogContent>
                    La solicitud fue cerrada con éxito.
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="primary">
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default VerQuejasSugerencias;
